<template>
    <section class="pt-10" id="destination" style="background: #f8f9fa;">
        <!-- Loader Overlay -->
        <div id="overlay" class="overlay" style="display: none;">
            <div id="loader" class="loader">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>

        <div class="container">
            <!-- Place Detail Header -->
            <div class="place-detail text-center mb-5">
                <div class="card shadow border-0">
                    <div class="card-body">
                        <!-- <h2 class="mb-3 mt-2 fw-bold text-primary">{{ place.name }}</h2> -->
                        <h4 class="card-title text-primary mb-4 text-center mt-3">Booking Summary</h4>

                        <div class="card">
                            <div class="row">
                                <!-- Adults -->
                                <div class="card col-md-3 mb-3">
                                    <div class="card-body text-center">
                                        <p class="card-text"><strong>Adults</strong><br> 0{{ adults }}</p>
                                    </div>
                                </div>
                                <!-- Children -->
                                <div class="card col-md-3 mb-3">
                                    <div class="card-body text-center">
                                        <p class="card-text"><strong>Children</strong><br> 0{{ children }}</p>
                                    </div>
                                </div>

                                <!-- Check-in Date -->
                                <div class="card col-md-3 mb-3">
                                    <div class="card-body text-center">
                                        <p class="card-text"><strong>Arrival Date</strong><br> {{ checkIn }}</p>
                                    </div>
                                </div>
                                <!-- Check-out Date -->
                                <div class="card col-md-3 mb-3">
                                    <div class="card-body text-center">
                                        <p class="card-text"><strong>Depature Date</strong><br> {{ checkOut }}</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                  

                </div>
            </div>

            <!-- Location Section Full Width -->
            <div class="row mb-4">
                <div class="col-6">
                    <div class="card shadow border-0">
                        <div class="card-body">
                            <h4 class="card-title text-primary mb-4 text-start mt-3">Select Interested Provinces</h4>
                            <div class="row">
                                <!-- Provinces Checklist -->
                                <div class="card col-md-4 mb-3" v-for="(province, index) in ProvincesList" :key="index">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" :id="'province-' + index"
                                            v-model="province.checked">
                                        <label class="form-check-label" :for="'province-' + index">{{ province.name
                                            }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- category Selection -->
                <div class="col-6">
                    <div class="card shadow border-0">
                        <div class="card-body">
                            <h4 class="card-title text-primary mb-4 text-start mt-3">Select Interested Categories</h4>
                            <div class="row">
                                <!-- Activities Checklist -->
                                <div class="card col-md-4 mb-3" v-for="(category, index) in CategoryList" :key="index">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" :id="category.id"
                                            v-model="category.checked">
                                        <label class="form-check-label" :for="category.id">{{ category.label }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Activities Selection -->
            <div class="row mb-4">
                <div class="col-12">
                    <div class="card shadow border-0">
                        <div class="card-body">
                            <h4 class="card-title text-primary mb-4 text-start mt-3">Select your fun activities</h4>
                            <div class="row">
                                <!-- Activities Checklist -->
                                <div class="card col-md-2 mb-3" v-for="(cardActivities, index) in activitiesList"
                                    :key="index">
                                    <div class="form-check" v-for="(activity, activityIndex) in cardActivities"
                                        :key="activityIndex">
                                        <input class="form-check-input" type="checkbox" :id="activity.id"
                                            v-model="activity.checked">
                                        <label class="form-check-label" :for="activity.id">{{ activity.label }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Special Activities Comments -->
            <div class="row mb-4">
                <div class="col-12">
                    <div class="card shadow border-0">
                        <div class="card-body">
                            <h4 class="card-title text-primary mb-2 text-start mt-3">
                                Tell us what you do!
                            </h4>
                            <div class="col-12">
                                <textarea theme="snow" toolbar="full" v-model="comments" class="form-control"
                                    style="height: 150px; border-radius: 5px;" id="comments" name="comments">
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Special Requirements -->
            <div class="row mb-4">
                <div class="col-12">
                    <div class="card shadow border-0">
                        <div class="card-body">
                            <h4 class="card-title text-primary mb-2 text-start mt-3">
                                Tell us if you need our attention.
                                <br>
                                <label style="color: black; font-size: 10px;">- Ex: Disability atention, Food
                                    allergies, Pet allergies -</label>
                            </h4>
                            <div class="col-12">
                                <textarea theme="snow" toolbar="full" v-model="comments2" class="form-control"
                                    style="height: 150px; border-radius: 5px;" id="comments2" name="comments2">
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Submit Button -->
            <div class="row mb-4">
                <div class="col-12 text-center">
                    <button class="col-12 btn btn-primary fw-1000" id="saveRequest" @click="saveRequest">
                        Get Quotations from Tour & Travel Organizers
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
//import { quillEditor } from 'vue3-quill';
import $ from 'jquery';
import Swal from 'sweetalert2'; // Import SweetAlert2


export default {
    components: {
        //quillEditor,
    },
    data() {
        return {
            adults: this.$route.query.adults || 0,
            children: this.$route.query.children || 0,
            checkIn: this.$route.query.checkIn || null,
            checkOut: this.$route.query.checkOut || null,
            place: JSON.parse(this.$route.query.place || '{}'),
            comments: '',
            comments2: '',
            activitiesList: [
                [
                    { id: 'snorkeling', label: 'Snorkeling', checked: false },
                    { id: 'jetSki', label: 'Jet Ski', checked: false },
                    { id: 'beachVolleyball', label: 'Beach Volleyball', checked: false },
                    { id: 'sunbathing', label: 'Sunbathing', checked: false },
                    { id: 'beachParty', label: 'Beach Party', checked: false },
                    { id: 'tanning', label: 'Tanning', checked: false },
                ],
                [
                    { id: 'beachWalking', label: 'Beach Walking', checked: false },
                    { id: 'boogieBoarding', label: 'Boogie Boarding', checked: false },
                    { id: 'nightSnorkeling', label: 'Night Snorkeling', checked: false },
                    { id: 'seaKayaking', label: 'Sea Kayaking', checked: false },
                    { id: 'surfing', label: 'Surfing', checked: false },
                    { id: 'paddleboarding', label: 'Paddle Boarding', checked: false },
                ],
                [
                    { id: 'fishing', label: 'Fishing', checked: false },
                    { id: 'beachYoga', label: 'Beach Yoga', checked: false },
                    { id: 'kiteSurfing', label: 'Kite Surfing', checked: false },
                    { id: 'parasailing', label: 'Parasailing', checked: false },
                    { id: 'whaleWatching', label: 'Whale Watching', checked: false },
                    { id: 'dolphinWatching', label: 'Dolphin Watching', checked: false },
                ],
                [
                    { id: 'coastalHiking', label: 'Coastal Hiking', checked: false },
                    { id: 'scubaDiving', label: 'Scuba Diving', checked: false },
                    { id: 'islandHopping', label: 'Island Hopping', checked: false },
                    { id: 'culturalTour', label: 'Cultural Tour', checked: false },
                    { id: 'wildlifeSafari', label: 'Wildlife Safari', checked: false },
                    { id: 'beachPicnic', label: 'Beach Picnic', checked: false },
                ],
                [
                    { id: 'camping', label: 'Camping', checked: false },
                    { id: 'sandcastleBuilding', label: 'Sandcastle Build', checked: false },
                    { id: 'snorkelingTour', label: 'Snorkeling Tour', checked: false },
                    { id: 'treeTopWalk', label: 'Tree Top Walk', checked: false },
                    { id: 'cookingClass', label: 'Cooking Class', checked: false },
                    { id: 'villageTour', label: 'Village Tour', checked: false },
                ],
                [
                    { id: 'horsebackRiding', label: 'Horseback Riding', checked: false },
                    { id: 'zipLining', label: 'Zip Lining', checked: false },
                    { id: 'rockClimbing', label: 'Rock Climbing', checked: false },
                    { id: 'farmingExperience', label: 'Farming Experience', checked: false },
                    { id: 'fruitPicking', label: 'Fruit Picking', checked: false },
                    { id: 'spiceTour', label: 'Spice Tour', checked: false },
                ]
            ],
            ProvincesList: [],
            CategoryList: [],
        };
    },
    mounted() {
        this.getProvince();
        this.getCategories();


    },
    methods: {
        getProvince() {
            const countryId = 208;
            $.ajax({
                url: process.env.VUE_APP_API_URL +`/getProvinces/${countryId}`,
                type: 'GET',
                dataType: 'json',
                success: (response) => {
                    // Assuming your provinces have a `name` and `id`
                    this.ProvincesList = response.filter(province => province.name.includes("Province"))
                        .map(province => ({
                            id: province.id,
                            name: province.name.replace("Province", "").trim(),
                            checked: this.place.district == province.name, // Auto select if previously selected
                        }));
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    console.error('Error fetching provinces:', textStatus, errorThrown);
                },
            });
        },
        getCategories() {
            $.ajax({
               url: process.env.VUE_APP_API_URL +'/getPlaceCategories',
                type: 'GET',
                dataType: 'json',
                success: (response) => {
                    this.CategoryList = response.map(category => ({
                        id: category.id,
                        label: category.name,
                        checked: this.place.cat == category.id, // Auto select if previously selected
                    }));
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    console.error('Error fetching categories:', textStatus, errorThrown);
                },
            });
        },

        saveRequest() {

            console.log(this.CategoryList);
            // Show the loader
            document.getElementById('overlay').style.display = 'block';

            // Prepare the activities array
            let selectedActivities = [];
            this.activitiesList.forEach(group => {
                // Check if group is an array
                if (Array.isArray(group)) {
                    group.forEach(activity => {
                        if (activity.checked) {
                            selectedActivities.push(activity.label);
                        }
                    });
                }
            });


            // Prepare the categories array
            let selectedCategories = [];
            this.CategoryList.forEach(item => {
                // Check if the item is an array
                if (Array.isArray(item)) {
                    item.forEach(category => {
                        if (category.checked) {
                            selectedCategories.push(category.id);
                        }
                    });
                } else if (item.checked) { // Handle the case for non-array items
                    selectedCategories.push(item.id);
                }
            });
            // Prepare the provinces array
            let selectedProvinces = [];
            this.ProvincesList.forEach(item => {
                // Check if the item is an array
                if (Array.isArray(item)) {
                    item.forEach(province => {
                        if (province.checked) {
                            selectedProvinces.push(province.id);
                        }
                    });
                } else if (item.checked) { // Handle the case for non-array items
                    selectedProvinces.push(item.id);
                }
            });
            // Retrieve user information from local storage
            var user = JSON.parse(localStorage.getItem('user'));
            var userId = user?.id; // Use optional chaining to avoid errors if user is null or undefined

            // Prepare the data for the API request
            const bookingData = {
                provinces: selectedProvinces, // Use the array you prepared
                cus_id: userId,
                categories: selectedCategories, // Fix spelling from "cateories" to "categories"
                tour_detail: {
                    adults: this.adults,
                    children: this.children,
                    check_in_date: this.checkIn,
                    check_out_date: this.checkOut,
                    activities: selectedActivities,
                    special_activities: this.comments,
                    special_requirements: this.comments2
                }
            };

            // Proceed with the API request using bookingData
            console.log(bookingData);




            // AJAX request using jQuery $.ajax method
            // Make the AJAX call
            $.ajax({
               url: process.env.VUE_APP_API_URL +'/saveRequest', // Replace with your actual API endpoint
                type: 'POST',
                contentType: 'application/json', // Send data as JSON
                data: JSON.stringify(bookingData), // Convert the data object to JSON
                success: (response) => {
                    // Log the response for debugging
                    console.log("Server response:", response);

                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Your request has been sent to our tour organizers. You will receive a match soon.',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            // Code to execute after clicking "OK"
                            // For example, redirecting to another page
                            window.location.href = '/'; // Replace with your desired URL
                        }
                    });
                },
                error: (jqXHR, textStatus, errorThrown) => {
                    console.error('Error saving booking:', textStatus, errorThrown);
                    alert('Error saving booking. Please try again later.');
                }
            });


        }
    }
};
</script>

<style>
.overlay {
    position: fixed;
    /* Fixed position */
    top: 0;
    /* Cover the top */
    left: 0;
    /* Cover the left */
    right: 0;
    /* Cover the right */
    bottom: 0;
    /* Cover the bottom */
    background: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    z-index: 1000;
    /* Ensure it appears above other content */
    display: flex;
    /* Use flex to center the loader */
    justify-content: center;
    /* Center horizontally */
    align-items: center;
    /* Center vertically */
}

.loader {
    position: fixed;
    /* Fixed position */
    left: 50%;
    /* Center horizontally */
    top: 50%;
    /* Center vertically */
    transform: translate(-50%, -50%);
    /* Translate to center */
    z-index: 1000;
    /* Ensure it appears above other content */
}
</style>